export const EMPTY_FILE_MESSAGE = 'This file is empty. Please select a different file.';

// Returns true (and clears the input so the same file can be re-picked)
// when the selected file has no content.
export const rejectEmptyFile = (e, toast) => {
  const file = e.target.files?.[0];
  if (file && file.size === 0) {
    toast.error(EMPTY_FILE_MESSAGE);
    e.target.value = '';
    return true;
  }
  return false;
};
